import { RedirectSelectInsurance } from 'src/app/models/type/redirect-select-insurance.enum';
import { ProductModel } from '../select-plans/product-personal-accident.model';
import { PlanGroupRiderModel } from '../select-plans/product-rider.model';
import { RuleMessageModel } from '../select-plans/rule-message.model';
import {SelfPackageInfo} from './self-package.info';
import {SelfPackageModel} from "../save-model/self-package-model";

export class SelfPackageFactoryModel {
  tab?: string;
  insurancePlan?: ProductModel;
  riderPlan?: Array<PlanGroupRiderModel>;
  sumCowrieExtra?: any;
  redirectToSelfPackage?: RedirectSelectInsurance;
  personalPlan?: ProductModel;
  personalMemberPlan?: ProductModel;
  personalMemberInfo?: any;
  selfPackageInfo?: SelfPackageInfo;
  totalSumCowrie?: any;
  isWarning?: boolean;
  warningMessage?: Array<RuleMessageModel>;
  quotationInfo?: SelfPackageModel;

  insurancePlanOld?: ProductModel;
  riderPlanOld?: Array<PlanGroupRiderModel>;

  constructor(
    tab?: string,
    insurancePlan?: ProductModel,
    riderPlan?: Array<any>,
    sumCowrieExtra?: any,
    redirectToSelfPackage?: RedirectSelectInsurance,
    personalPlan?: ProductModel,
    personalMemberPlan?: ProductModel,
    personalMemberInfo?: any,
    selfPackageInfo?: SelfPackageInfo) {
    this.tab = tab;
    this.insurancePlan = insurancePlan ? insurancePlan : new ProductModel();
    this.personalPlan = personalPlan ? personalPlan : new ProductModel();
    this.personalMemberPlan = personalMemberPlan ? personalMemberPlan : new ProductModel();
    this.riderPlan = riderPlan;
    this.personalMemberInfo = personalMemberInfo;
    this.sumCowrieExtra = sumCowrieExtra;
    this.redirectToSelfPackage = redirectToSelfPackage;
    this.selfPackageInfo = selfPackageInfo;
  }
}
